import Vue from 'vue';
import _store from '@/store';

export { _store as store };

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
    // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);
    editor: { active: false },
    form: {
      id: '',
      classRoomInput: { // Object (Required)
        sectionNo: null,
        teacherCode: '',
        subjectCode: '',
        nameLocal: '',
        nameEng: '',
        studentRegisterQty: 0,
        capacity: 0,
        startDate: '',
        endDate: '',
        isAvailable: true,
        isActive: true,
      },
      degreeId: '',
      subjectGroupId: '',
      classRoomOwnedId: '',
      courseOutlineRegistrationId: '',
      classSectionId: '',
      teacherId: '',
      subjectId: '',
      classRoomTypeIdId: '',
      classSection: {
        id: '',
        courseOutlineId: '',
        courseOutlineRegistrationId: '',
        vdoSetId: '',
        vdoSetCode: '',
        sectionNo: null,
        descriptionLocal: '',
        descriptionEng: '',
        studentRegisterQty: 0,
        studentQty: 0,
        startClassDate: new Date(),
        learnSpanNo: 1,
        examSpanNo: 1,
      }

    },

    isProcessing: false,

    filters: {
      isActive: true,
      isAvailable: true,
      isEmptyRoom: false,
    },

    //manual data
    selectedClassRoomOwned: null,
    selectedDegree: null,
    selectedSubjectGroup: null,
    selectedSubject: null,
    selectedTeacher: null,
    selectedVdoSet: null,

    academicPeriodConfig: null,

    classRooms: [],
    courseOutline: null,
    courseOutlineRegistration: null,
    subjects: [],
    availableClassRoomsOwned: [],
    courseOutlines: [],
    vdoSets: [],
    classSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  })
};

export const template = {
  table: {
    header: [
      {title: 'class-room.no', id: 'no'},
      {title: 'class-room.class-room', id: 'nameLocal'},
      // { title: 'class-room.class-room-type', id:'classRoomType'},
      // { title: 'class-room.degree', id:'degree'},
      // { title: 'class-room.subject', id:'subject'},
      {title: 'class-room.teacher', id: 'teacher'},
      {title: 'class-room.student-qty', id: 'studentRegisterQty'},
      {title: 'class-room.start-date', id: 'startDate'},
      {title: 'class-room.end-date', id: 'endDate'},
      {title: 'class-room.is-active', id: 'isActive'},
      {title: 'class-room.is-available', id: 'isAvailable'},
      {title: '',},

    ]
  }
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

export const initData = async (func) => {
  //use state
  if (func.getDegrees && (!state.store.Degree.degrees || state.store.Degree.degrees.length === 0)) {
    await func.getDegrees();
  }
  if (func.getSubjectGroups && (!state.store.SubjectGroup.subjectGroups || state.store.SubjectGroup.subjectGroups.length === 0)) {
    await func.getSubjectGroups();
  }
  // if (func.getTeachersDdl && (!state.store.Teacher.teachers || state.store.Teacher.teachers.length === 0)) {
    await func.getTeachersDdl();
  // }

  //use local
  if (func.getCurrentAcademicPeriodConfig && !state.local.academicPeriodConfig) {
    state.local.academicPeriodConfig = await func.getCurrentAcademicPeriodConfig();
  }

};

export const loadData = async (func) => {
  let payload = {
    classRoomFilterInput: {
      degreeId: state.local.selectedDegree ? state.local.selectedDegree.id : '',
      subjectGroupId: state.local.selectedSubjectGroup ? state.local.selectedSubjectGroup.id : '',
      subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
      teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
      isActive: state.local.filters.isActive,
      isAvailable: state.local.filters.isAvailable,
      isEmptyRoom: state.local.filters.isEmptyRoom,
    }
  };
  if (func.getClassRoomsByFilter) {
    state.local.classRooms = await func.getClassRoomsByFilter(payload);
  }
};

export const clearFormData = () => {
  state.local.form = {
    id: '',
    classRoomInput: { // Object (Required)
      sectionNo: null,
      teacherCode: '',
      subjectCode: '',
      nameLocal: '',
      nameEng: '',
      studentRegisterQty: 0,
      capacity: 0,
      startDate: '',
      endDate: '',
      isAvailable: true,
      isActive: true,
    },
    degreeId: '',
    subjectGroupId: '',
    classRoomOwnedId: '',
    courseOutlineRegistrationId: '',
    classSectionId: '',
    teacherId: '',
    subjectId: '',
    classRoomTypeId: '',
    classSection: {
      id: '',
      courseOutlineId: '',
      courseOutlineRegistrationId: '',
      vdoSetId: '',
      vdoSetCode: '',
      sectionNo: null,
      descriptionLocal: '',
      descriptionEng: '',
      studentRegisterQty: 0,
      studentQty: 0,
      startClassDate: new Date(),
      learnSpanNo: 1,
      examSpanNo: 1,
    }
  };

  //manual data

  state.local.selectedClassRoomOwned = null;
  // state.local.selectedDegree = null;
  // state.local.selectedSubjectGroup = null;
  // state.local.selectedSubject = null;
  // state.local.selectedTeacher = null;
  state.local.selectedVdoSet = null;

  state.local.courseOutline = null;
  state.local.courseOutlineRegistration = null;
  state.local.vdoSets = [];
};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

